import { INFO_SIG } from './types'
import api from './api'
import { toastMessage } from '../utils/Utils'

export const showInfoSignatario = (signatario) => {
    return dispatch => {
        dispatch({ type: INFO_SIG, payload: { infos: signatario }})
    }
}

export const setTypesSig = (tipo, callback = () => null) => {
    return dispatch => {
        dispatch({ type: INFO_SIG, payload: { load_signatario: true } })
        api.post('/signatario/type', { tipo })
        .then( res => {
            let payload = {
                load_signatario: false, 
                msg_response: 'Tipo de signatario adicionado com sucesso', 
                error_response: false 
            }
            dispatch({ type: INFO_SIG, payload })
            callback(true)
        })
        .catch( error => {
            //const { message } = error.response.data
            let payload = {
                load_signatario: false, 
                msg_response: 'Erro ao cadastrar tipo de signatario', 
                error_response: true 
            }
            dispatch({ type: INFO_SIG, payload})
            callback(false)
        })
    }
}

export const getTypesSig = () => {
    return dispatch => {
        dispatch({ type: INFO_SIG, payload: { load_signatario: true } })
        api.get('/signatario/types')
        .then( res => {
            const { list } = res.data.payload
            let payload = {
                tiposSignatarios: list,
                load_signatario: false, 
                msg_response: '', 
                error_response: false 
            }
            dispatch({ type: INFO_SIG, payload})
        })
        .catch( error => {
            const { message } = error.response.data
            let payload = {
                load_signatario: false, 
                msg_response: message, 
                error_response: true 
            }
            dispatch({ type: INFO_SIG, payload})
        })
    }
}

export const removeTipoSignatario = (data, callback = () => null) => {
    return dispatch => {
        dispatch({ type: INFO_SIG, payload: { load_signatario: true } })
        api.delete('signatario/type', { data })
        .then( res => {
            dispatch({ type: INFO_SIG, payload: { load_signatario: false } })
            toastMessage('success', res.data.message)
            callback(true)
        })
        .catch( error => {
            dispatch({ type: INFO_SIG, payload: { load_signatario: false } })
            toastMessage('error',error.message)
            callback(false)
        })
    }
}